<template>
    <section v-show="item.selected">
        <p><b>Адрес:</b> {{item.object.display_name | fallback}}</p>
        <p><b>Положение:</b> {{item.object.position.lat }}, {{item.object.position.lon}}</p>
    </section>
</template>

<script>
    export default {
        props: ['item']
    }
</script>

<style scoped></style>


// WEBPACK FOOTER //
// SputnikShape.vue?76a1d07e